// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox-module__checkbox--Z4pTj","checkboxInput":"Checkbox-module__checkboxInput--Ae1KE"};